//In the future, prepare as a separate component with structure and logic
import styled from "styled-components";

export const InputField = styled.div`
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};
  justify-content: space-between;
  flex-wrap: wrap;
  input {
    display: flex;
    width: ${({ column }) => (column ? "100%" : "200px")};
    height: 40px;
    padding: 5px 10px;
    border: 1px solid ${({ theme }) => theme.colors.grey1};
    font-size: ${({ theme }) => theme.fontSize.m};
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    &:placeholder {
      color: ${({ theme }) => theme.colors.grey1};
    }
  }
  label {
    display: flex;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.dark};
    font-size: ${({ theme }) => theme.fontSize.m};
    font-style: normal;
    font-weight: 400;
    line-height: 1.2;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: JetBrains Mono;
      font-size: ${({ theme }) => theme.fontSize.m};
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      width: 21px;
      height: 21px;
      padding: 0px 5px;
      border-radius: 100px;
      background: ${({ theme }) => theme.colors.red};
      color: ${({ theme }) => theme.colors.white};
      cursor: pointer;
    }
  }

  .error,
  .tip {
    font-size: ${({ theme }) => theme.fontSize.s};
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    width: 100%;
    margin: 0;
  }

  .error {
    color: ${({ theme }) => theme.colors.red};
    margin-top: 1px;
  }
  .tip {
    color: ${({ theme }) => theme.colors.dark};
    margin-bottom: 3px;
    padding-top: 5px;
    max-height: 0px;
    transition: 0.3s ease-in-out;
    visibility: hidden;
    &.active {
      visibility: visible;
      max-height: 75rem;
    }
  }
`;
